// @flow

export const coreEasing = 'cubic-bezier(0.52, 0.16, 0.24, 1)';
